/** Removes the static #bootstrap-app spinner used by notification/external-features index.html. */
export function removeBootstrapOverlay(): void {
  document.querySelector('#bootstrap-app')?.remove();
}

export function toggleSplashScreenVisibility(object: { show: boolean } = { show: false }) {
  const hiddenClass = 'svc-splash-screen-hidden';
  const body = document.body;
  if (!(object?.show ?? false)) {
    !body.classList.contains(hiddenClass) && body.classList.add(hiddenClass);
  } else {
    body.classList.contains(hiddenClass) && body.classList.remove(hiddenClass);
  }
}
